import { render, staticRenderFns } from "./PlatformList.vue?vue&type=template&id=1ec4b010&scoped=true"
import script from "./PlatformList.vue?vue&type=script&lang=ts"
export * from "./PlatformList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec4b010",
  null
  
)

export default component.exports